import styled from 'styled-components';

export const Matchstyles = styled.div`
  .match-wrap {
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    padding: 0;
    transition:
      transform 520ms cubic-bezier(0.22, 1, 0.36, 1),
      opacity 300ms ease;
    will-change: transform;
  }

  .flag-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 165px;
    height: 84px;
    background-color: transparent;
  }

  // finals
  .final-match-wrap {
    position: relative;
    width: 275px;
    height: 356px;
  }

  .world-cup-images-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .flag1 {
    position: absolute;
    left: 7px;
    top: 81px;
    width: 100px;
    height: 61px;
  }

  .flag2 {
    position: absolute;
    left: 167px;
    top: 81px;
    width: 100px;
    height: 61px;
  }

  .world-cup-image {
    position: absolute;
    left: 96px;
    top: 75px;
    width: 78px;
    height: auto;
  }
`;
